import {
  format,
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subWeeks,
  subMonths,
  subDays,
  startOfYesterday,
  endOfYesterday,
} from 'date-fns'
import { t } from '@/locales/i18n'
import type { Street } from '@/types/api/reports'

function sitesOptions() {
  return [
    { id: 'PokerStars', img: 'pokerstars', name: 'PokerStars' },
    { id: 'Party', img: 'party', name: 'PartyPoker', aliases: ['PartyPoker'] },
    { id: 'GGPoker', img: 'ggpoker', name: 'GG Poker', aliases: ['GG Poker', 'GGNetwork'] },
    { id: 'Ignition', img: 'ignition', name: 'Ignition' },
    { id: 'WPN', img: 'wpn_removed-trademark-issue', name: 'WPN' }, // replaced due to trademark issue
    { id: 'Winamax', img: 'winamax', name: 'Winamax', aliases: ['Winamax.fr'] },
    { id: 'Ipoker', img: 'ipoker', name: 'iPoker', aliases: ['iPoker'] },
    { id: 'Poker888', img: 'poker888', name: '888', aliases: ['888', '888poker', '888Poker'] },
    { id: 'PPPoker', img: 'pppoker', name: 'PPPoker' },
    { id: 'PokerBros', img: 'pokerbros', name: 'PokerBros' },
    { id: 'Unibet', img: 'unibet', name: 'Unibet' },
    { id: 'CoinPoker', img: 'coinpoker', name: 'CoinPoker' },
    { id: 'Chico', img: 'chico', name: 'Chico' },
    { id: 'UPoker', img: 'upokerx32', name: 'Upoker' },
    { id: 'Horizon', img: 'horizonx32', name: 'Horizon' },
    { id: 'Events', img: 'events', name: 'Events' },
  ]
}

function fairplaySitesOptions() {
  return [
    { id: 'Ipoker', img: 'ipoker', name: 'iPoker', email: 'security.corp@playtech.com' },
    {
      id: 'WPN',
      img: 'wpn_removed-trademark-issue',
      name: 'WPN',
      email: 'GameIntegrity@WinningPokerNetwork.com',
    },
    // replaced due to trademark issue
    {
      id: 'WPTglobal',
      img: 'wptglobal1',
      name: 'WPT Global',
      email: 'customercare@wptglobal.com',
      aliases: ['WPT Global'],
    },
    {
      id: 'PokerStars',
      img: 'pokerstars',
      name: 'PokerStars',
      email: 'gameintegrity@starsaccount.com',
      aliases: ['pokerstars'],
    },
    { id: 'GGPoker', img: 'ggpoker', name: 'GG Poker', email: 'security@ggnetwork.com' },
    {
      id: 'Party',
      img: 'party',
      name: 'PartyPoker',
      email: 'gameintegrity@partypoker.com',
      aliases: ['PartyPoker'],
    },
    { id: 'Winamax', img: 'winamax', name: 'Winamax', email: 'integrite.jeu@winamax.fr' },
    { id: 'Poker888', img: 'poker888', name: '888 poker', email: 'support@888.com' },
    { id: 'CoinPoker', img: 'coinpoker', name: 'CoinPoker', email: 'support@coinpoker.com' },
    { id: 'Ignition', img: 'ignition', name: 'Ignition', email: 'service@ignitioncasino.eu' },
  ]
}

function allSitesOptions() {
  return [
    ...sitesOptions(),
    { id: 'WePoker', img: 'wepoker', name: 'WePoker' },
    { id: 'PokerTime', img: 'pokertime', name: 'PokerTime' },
    { id: 'PokerMaster', img: 'pokermaster', name: 'PokerMaster' },
  ]
}

function getCompleteSitesOptions() {
  // TODO there some duliticites in these ... should be fixed
  return [
    ...fairplaySitesOptions(),
    ...allSitesOptions(),
    { id: 'GTOWizard', img: 'Logo_GTOWizard', name: 'GTO Wizard' }, // this name is used in IcmStructuresTables
    { id: 'PLayMode', img: 'Logo_GTOWizard', name: 'Play Mode' },
    { id: 'adda52', img: 'adda52', name: 'adda52' },
    { id: 'betmgm', img: 'bet_mg_poker', name: 'bet_mg_poker' },
    { id: 'bodog', img: 'bodog', name: 'bodog' },
    { id: 'global poker', img: 'global_poker', name: 'global_poker' },
    { id: 'idnpoker', img: 'idn_poker', name: 'idn_poker' },
    { id: 'microgame', img: 'microgame', name: 'microgame' },
    { id: 'ok poker', img: 'ok_poker', name: 'ok_poker' },
    { id: 'planetwin365', img: 'planet_win_365', name: 'planet_win_365' },
    { id: 'pocket52', img: 'pocket_52', name: 'pocket_52' },
    { id: 'pokerbaazi', img: 'poker_brazil', name: 'poker_brazil' },
    { id: 'pokerbet', img: 'pokerbet', name: 'pokerbet' },
    { id: 'revolution', img: 'revlution', name: 'revolution' },
    { id: 'skypoker', img: 'sky_poker', name: 'sky_poker' },
    { id: 'spartan poker', img: 'spartan_poker', name: 'spartan_poker' },
    { id: 'wsop', img: 'wsop', name: 'wsop' },
  ]
}

export type TCorrectnessMoveType =
  | 'na'
  | 'best_move'
  | 'correct_move'
  | 'inaccuracy'
  | 'wrong_move'
  | 'blunder'
export type TCorrectnessActionGroups = Record<
  TCorrectnessMoveType,
  {
    rank: number
    res_id: string
    res_group: string
    streak_status: string
    color: string
    icon: string
  }
>

function getCorrectnessActionGroups() {
  return {
    na: {
      rank: 1,
      res_id: 'na',
      res_group: 'na',
      streak_status: 'neutral',
      color: '--clr-blue',
      icon: 'mdi-progress-alert',
    },
    best_move: {
      rank: 2,
      res_id: 'best_move',
      res_group: 'ok',
      streak_status: 'win',
      color: '--clr-primary',
      icon: 'mdi-check-all',
    },
    correct_move: {
      rank: 3,
      res_id: 'correct_move',
      res_group: 'ok',
      streak_status: 'win',
      color: '--clr-primary',
      icon: 'mdi-check',
    },
    inaccuracy: {
      rank: 4,
      res_id: 'inaccuracy',
      res_group: 'semi-ok',
      streak_status: 'loss',
      color: '--clr-yellow',
      icon: 'mdi-information-outline',
    },
    wrong_move: {
      rank: 5,
      res_id: 'wrong_move',
      res_group: 'not-ok',
      streak_status: 'loss',
      color: '--clr-error',
      icon: 'mdi-alert-circle-outline',
    },
    blunder: {
      rank: 6,
      res_id: 'blunder',
      res_group: 'not-ok',
      streak_status: 'loss',
      color: '--clr-error',
      icon: 'mdi-alert',
    },
  } as TCorrectnessActionGroups
}

function tierTags() {
  return [
    {
      id: 'free',
      text: 'FREE',
      icon: 'mdi-account-outline',
    },
    {
      id: 'trial',
      text: 'TRIAL',
      icon: 'mdi-account-clock-outline',
    },
    {
      id: 'starter',
      text: 'STARTER',
      icon: 'mdi-diamond-stone',
    },
    {
      id: 'premium',
      text: 'PREMIUM',
      icon: 'mdi-diamond-stone',
    },
    {
      id: 'elite',
      text: 'ELITE',
      icon: 'mdi-diamond-stone',
    },
  ]
}

const getDatepickerShortcutOptions = () => {
  const now = new Date()
  // @ts-expect-error
  const l_endOfToday = endOfToday(now)
  return [
    { id: 'any', name: t('datepicker.any'), date_from: '', date_to: '' },
    {
      id: 'yesterday',
      name: t('datepicker.yesterday'),
      date_from: startOfYesterday(),
      date_to: endOfYesterday(),
    },
    {
      id: 'today',
      name: t('datepicker.today'),
      // @ts-expect-error
      date_from: startOfToday(now),
      date_to: l_endOfToday,
    },
    {
      id: 'last_3_days',
      name: t('datepicker.last_xxx_days', { num: 3 }),
      date_from: subDays(now, 3),
      date_to: now,
    },
    {
      id: 'this_week',
      name: t('datepicker.this_week'),
      date_from: startOfWeek(now),
      date_to: l_endOfToday,
    },
    {
      id: 'last_week',
      name: t('datepicker.last_week'),
      date_from: startOfWeek(subWeeks(now, 1)),
      date_to: endOfWeek(subWeeks(now, 1)),
    },
    {
      id: 'this_month',
      name: t('datepicker.this_month'),
      date_from: startOfMonth(now),
      date_to: now,
    },
    {
      id: 'last_month',
      name: t('datepicker.last_month'),
      date_from: startOfMonth(subMonths(now, 1)),
      date_to: endOfMonth(subMonths(now, 1)),
    },
    {
      id: 'last_3_months',
      name: t('datepicker.last_xxx_months', { num: 3 }),
      date_from: startOfMonth(subMonths(now, 3)),
      date_to: l_endOfToday,
    },
  ]
}

function getDatepickerShortutDates(options = getDatepickerShortcutOptions().map(i => i.id)) {
  let res = getDatepickerShortcutOptions().filter(i => options.includes(i.id))

  res = res.map(i => {
    // @ts-expect-error
    const date_from = i.date_from ? format(i.date_from, 'yyyy-MM-dd') : ''
    // @ts-expect-error
    const date_to = i.date_to ? format(i.date_to, 'yyyy-MM-dd') : ''
    const result = { ...i, date_from, date_to }
    return result
  })

  return res
}
function getCardsValues() {
  return ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
}
function getCardsColors() {
  return ['s', 'h', 'd', 'c']
}
function getSuitsSymbols() {
  return {
    rainbow: ['h', 'd', 'c'],
    flush_draw: ['h', 'h', 'd'],
    monotone: ['h', 'h', 'h'],
  }
}
function getSuitsConf() {
  return {
    s: {
      value: 's',
      colorDefault: '--clr-default-spades',
      color: '--clr-spades',
      icon: `mdi-cards-spade`,
    },
    h: {
      value: 'h',
      colorDefault: '--clr-default-hearts',
      color: '--clr-hearts',
      icon: `mdi-cards-heart`,
    },
    d: {
      value: 'd',
      colorDefault: '--clr-default-diamonds',
      color: '--clr-diamonds',
      icon: `mdi-cards-diamond`,
    },
    c: {
      value: 'c',
      colorDefault: '--clr-default-clubs',
      color: '--clr-clubs',
      icon: `mdi-cards-club`,
    },
  }
}

function getGmfFormats() {
  return ['cash', 'mtt', 'spins', 'husng', 'straddle_ante_cash', 'custom']
}
function getGametypeOrder() {
  return ['cash', 'mtt', 'spins', 'husng', 'straddle_ante_cash', 'elite', 'any']
}
function getCategoriesHandIndex() {
  return [
    'no_made_hand',
    'king_high',
    'ace_high',
    'low_pair',
    'third_pair',
    'second_pair',
    'underpair',
    'top_pair',
    'overpair',
    'two_pair',
    'trips',
    'set',
    'straight',
    'flush',
    'fullhouse',
    'quads',
    'straight_flush',
  ]
}
function getCategoriesDrawsIndex() {
  return [
    'no_draw',
    'gutshot',
    'oesd',
    'flush_draw',
    'combo_draw',
    'bd_sd',
    'bd_fd',
    'low_bdfd',
    'mid_bdfd',
    'broadway_bdfd',
    'nut_bdfd',
    'bd_sdfd',
    'low_flush_draw',
    'mid_flush_draw',
    'broadway_flush_draw',
    'nut_flush_draw',
    'onecard_bdfd',
    'twocards_bdfd',
  ]
}
function getCategoriesEqBucketsIndex() {
  return ['best_hands', 'good_hands', 'weak_hands', 'trash_hands']
}
function getCategoriesEqBucketsAdvancedIndex() {
  return [
    'hands_90_100',
    'hands_80_90',
    'hands_70_80',
    'hands_60_70',
    'hands_50_60',
    'hands_25_50',
    'hands_0_25',
  ]
}

function getCategoriesColors() {
  return {
    // hands
    no_made_hand: '#ef5350',
    king_high: '#ec407a',
    ace_high: '#ab47bc',
    low_pair: '#7e57c2',
    third_pair: '#5c6bc0',
    second_pair: '#42a5f5',
    underpair: '#29b6f6',
    top_pair: '#26c6da',
    overpair: '#26a69a',
    two_pair: '#66bb6a',
    trips: '#9ccc65',
    set: '#d4e157',
    straight: '#ffee58',
    flush: '#ffca28',
    fullhouse: '#ffa726',
    quads: '#ff7043',
    straight_flush: '#8d6e63',

    // draws
    no_draw: '#ef5350',
    gutshot: '#ec407a',
    oesd: '#ab47bc',
    flush_draw: '#7e57c2',
    combo_draw: '#5c6bc0',
    bd_sd: '#42a5f5',
    bd_fd: '#29b6f6',
    low_bdfd: '#26c6da',
    mid_bdfd: '#26a69a',
    broadway_bdfd: '#66bb6a',
    nut_bdfd: '#9ccc65',
    bd_sdfd: '#d4e157',
    low_flush_draw: '#ffee58',
    mid_flush_draw: '#ffca28',
    broadway_flush_draw: '#ffa726',
    nut_flush_draw: '#ff7043',
    onecard_bdfd: '#8d6e63',
    twocards_bdfd: '#cd3e09',
  }
}

function getHandsCategoriesOptions() {
  return [
    'no_made_hand',
    'king_high',
    'ace_high',
    'low_pair',
    'third_pair',
    'second_pair',
    'underpair',
    'top_pair',
    'overpair',
    'two_pair',
    'trips',
    'set',
    'straight',
    'flush',
    'fullhouse',
    'quads',
    'straight_flush',
  ]
}
function getDrawsCategoriesOptions() {
  return [
    'no_draw',
    'onecard_bdfd',
    'twocards_bdfd',
    'gutshot',
    'oesd',
    'flush_draw',
    'nut_flush_draw',
    'combo_draw',
  ]
}
function getGroupsSelectionOptions() {
  return ['manual', 'hand_class', 'only_cd']
}

function mttHeroStackTypes() {
  return ['big', 'medium', 'small']
}

function shortcutTypes() {
  return [
    'RFI',
    'vsSRP',
    'vs3bet',
    'vs4bet',
    'vs5bet',
    'possibleSqueeze',
    'vsSqueeze',
    'vsLimp',
    'vsIso',
    'SRP',
    '3bet',
    '4bet',
    '5bet',
    'Squeeze',
    'limp',
    'iso',
    'StartOfHand',
  ]
}

// 'Shortdeck',
function getPracticeFilterGameformats() {
  return [
    'Cash',
    'HuSng',
    'MTT',
    'Spins',
    'Straddle_ante_cash',
    'Straddle_ante_cash_6max',
    'Custom',
  ]
}

function getLegalPositions() {
  return ['UTG', 'UTG+1', 'UTG+2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB', 'STR']
}

function getLabelColors() {
  return [
    '#F25C57',
    '#E97852',
    '#E5B466',
    '#EBCB44',
    '#B1D14D',
    '#569976',
    '#5ABEB9',
    '#8DCAC7',
    '#3761BE',
    '#6964EC',
    '#A05BCD',
    '#EF99EB',
  ]
}

const unitDecimals = {
  ante: 3,
  avg_ev_loss: 2,
  bb: 2, // big blinds
  bb_pot: 0, // % big blind by pot
  blind: 2, // blind in - custom tree settings
  blocker_rate: 0, //
  bounty: 0, // % bounty
  bubble_factor: 2, // bubble factor
  combos: 1, //
  e: 0, // e times min raise  - custom tree settings
  eq: 1, // equity
  eq_total: 2, // equity
  eqr: 1, // equity realization
  eqr_total: 2, // equity realization
  ev: 2, // estimated value
  ev_loss: 3,
  ev_pot: 1, // % ev in pot
  frequency_diff: 2,
  gto_score: 1, // gto score
  icm_payout_prize: 2,
  pot_odds: 1, // % pot odds
  rake_cap: 4, // rake cap
  rake_percent: 2, // % rake
  range: 2, // range 0.99
  range_percent: 1, // % 0.5
  risk_premium: 1, // risk premium
  strategy: 1, //  action.frequency or action.strategy
  strategy_eq: 1, // eq in sol. browser tab
  unblocker_rate: 0, //
  x: 1, // x times min raise  - custom tree settings
  dollar_ev: 2, // dollar ev
  table_equity: 2, // table equity
}

const gameModes = ['cash', 'mtt', 'spins', 'husng', 'straddle_ante_cash']

const urlLinks = {
  discord_invite: 'https://discord.com/invite/ht3QxrP',
  discord_invite_link: 'https://discord.gg/ht3QxrP',
}

const namespaces = {
  STUDY: 'study',
  REPORTS: 'rep',
}

const all_streets: Street[] = ['preflop', 'flop', 'turn', 'river']

export {
  getCorrectnessActionGroups,
  allSitesOptions,
  getCompleteSitesOptions,
  sitesOptions,
  fairplaySitesOptions,
  tierTags,
  getDatepickerShortutDates,
  getDatepickerShortcutOptions,
  getCardsValues,
  getCardsColors,
  getSuitsSymbols,
  getSuitsConf,
  getGametypeOrder,
  getCategoriesHandIndex,
  getCategoriesDrawsIndex,
  getCategoriesEqBucketsIndex,
  getCategoriesEqBucketsAdvancedIndex,
  getCategoriesColors,
  getGmfFormats,
  shortcutTypes,
  mttHeroStackTypes,
  getPracticeFilterGameformats,
  getLegalPositions,
  getLabelColors,
  unitDecimals,
  getHandsCategoriesOptions,
  getDrawsCategoriesOptions,
  getGroupsSelectionOptions,
  gameModes,
  urlLinks,
  namespaces,
  all_streets,
}
